import useFeatureFlags from 'common/hooks/useFeatureFlags';
import './AiBanner.scss';
import { Feature } from 'common/models/page-config.models';

function AiBanner() {
  const { hasFeature } = useFeatureFlags();

  if (!hasFeature(Feature.AiBanner)) {
    return null;
  }

  return (
    <div className="ai-banner-container">
      <span className="ai-banner-text">
        This tool leverages artificial intelligence.{' '}
        <a
          href="https://help.kwello.com/en/articles/9472448-elsieai-ai-acceptable-use-best-practices"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click here for acceptable use guidelines
        </a>
      </span>
    </div>
  );
}

export default AiBanner;
